import * as React from 'react';

const DownloadIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 17a.5.5 0 1 0 0-1h13a.5.5 0 0 0 0 1h-13zm6.853-3.035a.5.5 0 0 0 .707 0l4.333-4.334a.5.5 0 0 0-.707-.707l-3.48 3.48V3.5a.5.5 0 0 0-1 0v8.904l-3.48-3.48a.5.5 0 0 0-.707.707l4.334 4.334z"
      fill="currentColor"
    />
  </svg>
);

export default DownloadIcon;
